import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

/**
 * Ana sayfada 3D/AR menünün vitrini — ayrıntı `/ar-menu` sayfasında.
 *
 * Bu yerde eskiden "Başarı Hikayeleri" vardı: altı uydurma işletme, rastgele
 * avatar servisinden yüz fotoğrafı, "LinkedIn doğrulanmış" rozeti ve üründe
 * OLMAYAN özellikleri (pazaryeri entegrasyonu, sesli sipariş) öven yorumlar.
 * Görüşmede ilk sorulacak "bu işletmeyi arayabilir miyim?" sorusunun cevabı
 * yoktu. Gerçek bir referans izinle alındığında buraya o gelecek.
 *
 * Görsel sahte değil: poster, kendi tarama hattımızdan çıkan gerçek modelin
 * görüntüsü; 3D görüntüleyici bu sayfaya bilerek konmadı (ana paket şişmesin).
 */
const ArShowcaseSection = () => {
  return (
    <section id="ar-menu" className="relative py-20 bg-gray-950 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-30" aria-hidden="true">
        <div className="absolute top-0 right-1/4 w-96 h-96 rounded-full bg-amber-500 blur-[140px]" />
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-primary blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="order-2 lg:order-1">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-sm font-inter font-accent-medium mb-6">
            <span className="px-2 py-0.5 rounded-full bg-primary text-xs font-semibold">YENİ</span>
            QR Menü Pro
          </div>
          <h2 className="font-poppins font-heading-bold text-3xl md:text-4xl lg:text-5xl leading-tight">
            Menünüz artık{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-primary">
              3D ve AR
            </span>
          </h2>
          <p className="mt-6 font-open-sans text-lg text-gray-300 leading-relaxed">
            Misafir karekodu okutur, yemeği telefonunda çevirir ve “AR'da Gör” ile gerçek boyutunda
            masasına koyar. Uygulama indirmeden, iPhone'da ve Android'de. Modelleri ekibimiz sizin
            tabaklarınızdan tarar.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-4">
            {[
              { icon: 'Ruler', text: 'Porsiyon gerçek boyutunda görünür' },
              { icon: 'Smartphone', text: 'Uygulama kurulmaz, tarayıcıda açılır' },
              { icon: 'ScanEye', text: 'Her model yayından önce AR’da kontrol edilir' },
              { icon: 'Gauge', text: 'Model yalnızca misafir istediğinde iner' }
            ].map((item) => (
              <li key={item.text} className="flex items-start gap-3">
                <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={item.icon} size={18} className="text-amber-300" />
                </span>
                <span className="font-open-sans text-sm text-gray-200 pt-2">{item.text}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link
              to="/ar-menu"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-primary text-white font-poppins font-heading-semibold shadow-lg hover:opacity-95 transition"
            >
              3D modeli çevirin
              <Icon name="ArrowRight" size={18} />
            </Link>
            <a
              href="https://menu.cafeotomasyonu.com/demo-kafe"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl border border-white/25 text-white font-poppins font-heading-semibold hover:bg-white/10 transition"
            >
              <Icon name="Scan" size={18} />
              Demo menüde AR'ı deneyin
            </a>
          </div>
        </div>

        <Link to="/ar-menu" className="order-1 lg:order-2 group block" aria-label="3D/AR menü sayfasına git">
          <div className="relative mx-auto max-w-md">
            <div className="aspect-square rounded-[2rem] bg-gradient-to-b from-white to-amber-50 shadow-2xl overflow-hidden flex items-center justify-center">
              <img
                src="/assets/ar/coffee-cup-poster.webp"
                alt="Telefonla taranmış kahve fincanının 3D modeli"
                loading="lazy"
                className="w-[88%] object-contain group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute -bottom-5 -left-4 sm:-left-8 w-40 rounded-2xl overflow-hidden shadow-xl ring-4 ring-gray-950 rotate-[-6deg]">
              <img
                src="/assets/ar/capture-frame.webp"
                alt="Tarama sırasında çekilen gerçek kare"
                loading="lazy"
                className="w-full h-28 object-cover"
              />
              <p className="bg-white text-gray-900 text-[11px] font-inter font-accent-medium px-2 py-1">
                Çekim karesi → 3D model
              </p>
            </div>
            <span className="absolute top-4 right-4 px-3 py-1.5 rounded-full bg-gray-900/85 text-white text-xs font-inter font-accent-medium">
              Gerçek tarama
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default ArShowcaseSection;
